import { render, staticRenderFns } from "./productDisplay.vue?vue&type=template&id=c9b5a2b0&scoped=true"
import script from "./productDisplay.vue?vue&type=script&lang=js"
export * from "./productDisplay.vue?vue&type=script&lang=js"
import style0 from "./productDisplay.vue?vue&type=style&index=0&id=c9b5a2b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b5a2b0",
  null
  
)

export default component.exports